import merge from 'lodash/merge';
import { TFunction } from 'i18next';

import { getDefaultAtpConfig, getTemplateConfig } from './cfg.default';

const cfg = {
  isAsEnabled: false,
  policyType: 41,
  tmVirusscans: {
    vsTextTagSubjectContent: 'Suspicious File:',
    vsWormsTrojansActionType: 109,
  },

  tmFileblockings: {
    fbActionType: 109,
  },

  tmWebthreatprotections: {
    wtpApprovedHeaderList: '',
    wtpExtractAttachmentUrl: 1,
  },
};

export function getTeamsTemplateConfig(
  t: TFunction<'translation'>,
  accountEmail: string | undefined
) {
  const coverI18nKeys = [
    'policy.policyTemplate.MT.tmVirusscans.vsReplacementText',
    'policy.policyTemplate.MT.tmDdafilters.ddaReplacementText',
    'policy.policyTemplate.MT.tmFileblockings.fbReplacementFileName',
    'policy.policyTemplate.MT.tmFileblockings.fbReplacementText',
    'policy.policyTemplate.MT.tmWebthreatprotections.wtpReplacementText',
  ];
  const ntfI18nReplaceKeys = [
    'policy.policyTemplate.MT.tmAntispamfilters.notification.ntfAdminMessage',
    'policy.policyTemplate.MT.tmAntispamfilters.notification.ntfAdminSubject',
    'policy.policyTemplate.MT.tmAntispamfilters.notification.ntfInternalRecipientMessage',
    'policy.policyTemplate.MT.tmAntispamfilters.notification.ntfInternalRecipientSubject',
    'policy.policyTemplate.MT.tmFileblockings.notification.ntfAdminMessage',
    'policy.policyTemplate.MT.tmFileblockings.notification.ntfAdminSubject',
    'policy.policyTemplate.MT.tmFileblockings.notification.ntfInternalRecipientMessage',
    'policy.policyTemplate.MT.tmFileblockings.notification.ntfInternalRecipientSubject',
    'policy.policyTemplate.MT.tmVirusscans.notification.ntfAdminMessage',
    'policy.policyTemplate.MT.tmVirusscans.notification.ntfAdminSubject',
    'policy.policyTemplate.MT.tmVirusscans.notification.ntfInternalRecipientMessage',
    'policy.policyTemplate.MT.tmVirusscans.notification.ntfInternalRecipientSubject',
    'policy.policyTemplate.MT.tmWebthreatprotections.notification.ntfAdminMessage',
    'policy.policyTemplate.MT.tmWebthreatprotections.notification.ntfAdminSubject',
    'policy.policyTemplate.MT.tmWebthreatprotections.notification.ntfInternalRecipientMessage',
    'policy.policyTemplate.MT.tmWebthreatprotections.notification.ntfInternalRecipientSubject',
    'policy.policyTemplate.MT.tmDdafilters.notification.ntfAdminMessage',
    'policy.policyTemplate.MT.tmDdafilters.notification.ntfAdminSubject',
    'policy.policyTemplate.MT.tmDdafilters.notification.ntfInternalRecipientMessage',
    'policy.policyTemplate.MT.tmDdafilters.notification.ntfInternalRecipientSubject',
  ];
  const tempConfig = getDefaultAtpConfig();
  merge(tempConfig, cfg);
  return getTemplateConfig(
    t,
    tempConfig,
    accountEmail,
    coverI18nKeys,
    ntfI18nReplaceKeys
  );
}
